<script lang="ts" setup>
import { computed } from 'vue';
import { type VHeadingAppearance, type VHeadingLevel } from './types';

const props = defineProps<{
  level: VHeadingLevel;
  appearance?: VHeadingAppearance;
  id?: string;
}>();

const defaultAppearanceByLevel: Record<VHeadingLevel, VHeadingAppearance> = {
  1: '3xl',
  2: 'm',
  3: 'm',
  4: 'm',
  5: 'xs',
  6: 'xs',
};

const fontSizeByAppearance: Record<VHeadingAppearance, string> = {
  '3xl': 'text-3xl',
  '2xl': 'text-2xl',
  m: 'text-xl',
  sm: 'text-base',
  xs: 'text-sm',
};

const level = computed(() => props.level);
const appearance = computed(() => props.appearance ?? defaultAppearanceByLevel[props.level]);
</script>
<template>
  <component
    :is="`h${level}`"
    :class="`font-bold text-primary-900 ${fontSizeByAppearance[appearance]}`"
    :id="props.id"
  >
    <slot></slot>
  </component>
</template>
